import { Sample } from "@/comn/components/_";
import ReactECharts from "echarts-for-react";

const Line = () => {
    return (
        <ReactECharts
            option={{
                xAxis: {
                    type: "category",
                    data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        data: [150, 230, 224, 218, 135, 147, 260],
                        type: "line",
                    },
                ],
            }}
        />
    );
};

const Pie = () => {
    return (
        <ReactECharts
            option={{
                title: {
                    text: "Referer of a Website",
                    subtext: "Fake Data",
                    left: "center",
                },
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                },
                series: [
                    {
                        name: "Access From",
                        type: "pie",
                        radius: "50%",
                        data: [
                            { value: 1048, name: "Search Engine" },
                            { value: 735, name: "Direct" },
                            { value: 580, name: "Email" },
                            { value: 484, name: "Union Ads" },
                            { value: 300, name: "Video Ads" },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }}
        />
    );
};

const Bar = () => {
    return (
        <ReactECharts
            option={{
                xAxis: {
                    type: "category",
                    data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        data: [120, 200, 150, 80, 70, 110, 130],
                        type: "bar",
                    },
                ],
            }}
        />
    );
};

const Scatter = () => {
    return (
        <ReactECharts
            option={{
                xAxis: {},
                yAxis: {},
                series: [
                    {
                        symbolSize: 20,
                        data: [
                            [10.0, 8.04],
                            [8.07, 6.95],
                            [13.0, 7.58],
                            [9.05, 8.81],
                            [11.0, 8.33],
                            [14.0, 7.66],
                            [13.4, 6.81],
                            [10.0, 6.33],
                            [14.0, 8.96],
                            [12.5, 6.82],
                            [9.15, 7.2],
                            [11.5, 7.2],
                            [3.03, 4.23],
                            [12.2, 7.83],
                            [2.02, 4.47],
                            [1.05, 3.33],
                            [4.05, 4.96],
                            [6.03, 7.24],
                            [12.0, 6.26],
                            [12.0, 8.84],
                            [7.08, 5.82],
                            [5.02, 5.68],
                        ],
                        type: "scatter",
                    },
                ],
            }}
        />
    );
};

const Funnel = () => {
    return (
        <ReactECharts
            option={{
                title: {
                    text: "Funnel",
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c}%",
                },
                toolbox: {
                    feature: {
                        dataView: { readOnly: false },
                        restore: {},
                        saveAsImage: {},
                    },
                },
                legend: {
                    data: ["Show", "Click", "Visit", "Inquiry", "Order"],
                },
                series: [
                    {
                        name: "Funnel",
                        type: "funnel",
                        left: "10%",
                        top: 60,
                        bottom: 60,
                        width: "80%",
                        min: 0,
                        max: 100,
                        minSize: "0%",
                        maxSize: "100%",
                        sort: "descending",
                        gap: 2,
                        label: {
                            show: true,
                            position: "inside",
                        },
                        labelLine: {
                            length: 10,
                            lineStyle: {
                                width: 1,
                                type: "solid",
                            },
                        },
                        itemStyle: {
                            borderColor: "#fff",
                            borderWidth: 1,
                        },
                        emphasis: {
                            label: {
                                fontSize: 20,
                            },
                        },
                        data: [
                            { value: 60, name: "Visit" },
                            { value: 40, name: "Inquiry" },
                            { value: 20, name: "Order" },
                            { value: 80, name: "Click" },
                            { value: 100, name: "Show" },
                        ],
                    },
                ],
            }}
        />
    );
};

const CandleStick = () => {
    return (
        <ReactECharts
            option={{
                xAxis: {
                    data: ["2017-10-24", "2017-10-25", "2017-10-26", "2017-10-27"],
                },
                yAxis: {},
                series: [
                    {
                        type: "candlestick",
                        data: [
                            [20, 34, 10, 38],
                            [40, 35, 30, 50],
                            [31, 38, 33, 44],
                            [38, 15, 5, 42],
                        ],
                    },
                ],
            }}
        />
    );
};

const Radar = () => {
    return (
        <ReactECharts
            option={{
                title: {
                    text: "Basic Radar Chart",
                },
                legend: {
                    data: ["Allocated Budget", "Actual Spending"],
                },
                radar: {
                    // shape: 'circle',
                    indicator: [
                        { name: "Sales", max: 6500 },
                        { name: "Administration", max: 16000 },
                        { name: "Information Technology", max: 30000 },
                        { name: "Customer Support", max: 38000 },
                        { name: "Development", max: 52000 },
                        { name: "Marketing", max: 25000 },
                    ],
                },
                series: [
                    {
                        name: "Budget vs spending",
                        type: "radar",
                        data: [
                            {
                                value: [4200, 3000, 20000, 35000, 50000, 18000],
                                name: "Allocated Budget",
                            },
                            {
                                value: [5000, 14000, 28000, 26000, 42000, 21000],
                                name: "Actual Spending",
                            },
                        ],
                    },
                ],
            }}
        />
    );
};

const ChartSample = () => {
    return (
        <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col items-center justify-center">
                <div className="text-xl">아래 링크에서 차트 선택 후 적용 `option` 확인가능합니다</div>
                <a
                    className="text-blue underline text-xl"
                    href="https://echarts.apache.org/examples/en/index.html"
                    target="_blank"
                >
                    클릭 시 공식문서 예제페이지로 이동합니다
                </a>
                <br />
            </div>
            <Sample.Code>{`import ReactECharts from "echarts-for-react";

const Chart = () => {
    <ReactECharts
        option={{
            xAxis: {
                type: "category",
                data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            },
            yAxis: {
                type: "value",
            },
            series: [
                {
                    data: [150, 230, 224, 218, 135, 147, 260],
                    type: "line",
                },
            ],
        }}
    />
}
`}</Sample.Code>

            <div className="bg-white">
                <Line />
            </div>
            <div className="bg-white">
                <Pie />
            </div>
            <div className="bg-white">
                <Bar />
            </div>
            <div className="bg-white">
                <Scatter />
            </div>
            <div className="bg-white">
                <Funnel />
            </div>
            <div className="bg-white">
                <CandleStick />
            </div>
            <div className="bg-white">
                <Radar />
            </div>
        </div>
    );
};

export { ChartSample };
